// extracted by mini-css-extract-plugin
export var modalCancelBtn = "LinkButton-module--modalCancelBtn--5b130";
export var modalOkBtn = "LinkButton-module--modalOkBtn--8694c";